import styled from "styled-components";
import Image from "next/image";

const ImgForSEO = styled(Image)`
	display: none;
`;

export default ImgForSEO;